var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxSelected = function SvgCheckboxSelected(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 16,
    viewBox: "0 0 16 3",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 3,
    fill: "currentColor",
    rx: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxSelected);
export default ForwardRef;